import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * El catálogo de etiquetas de la organización (punto 11), en vivo: `organizations/{orgId}/etiquetas/catalogo`.
 * Fuera de una organización no hay catálogo (`cargado: true`, lista vacía): las etiquetas son de la organización.
 * Lo escribe sólo el callable `gestionarEtiquetasDeChat`; ver `utils/etiquetasDeChat.js`.
 */
export function useCatalogoDeEtiquetas(orgId) {
  const [estado, setEstado] = useState({ lista: [], cargado: !orgId });
  useEffect(() => {
    if (!orgId) { setEstado({ lista: [], cargado: true }); return undefined; }
    setEstado({ lista: [], cargado: false });
    return onSnapshot(
      doc(db, 'organizations', orgId, 'etiquetas', 'catalogo'),
      (snap) => setEstado({ lista: (snap.exists() && Array.isArray(snap.data().lista)) ? snap.data().lista : [], cargado: true }),
      (e) => { console.warn('[etiquetas] no se pudo leer el catálogo:', e?.message || e); setEstado({ lista: [], cargado: true }); },
    );
  }, [orgId]);
  return estado;
}
